
import request from '@/util/axios'

//获取店铺
export const getShopList = data => {
    return request({
      url: "/api/shop/List",
      method: 'post',
      data
    })
}
//tag 修改标签
export const setEditTag = data => {
  return request({
    url: "/api/ShopBranch/EditTag",
    method: 'post',
    data
  })
}

//tag 删除标签
export const deleteTag = id => {
  return request({
    url: "/api/ShopBranch/DeleteTag",
    method: 'post',
    data:{
      id
    }
  })
}

//获取店铺详情
export const getShopDetails = id => {
  return request({
    url: "/api/shop/DetailsPage",
    method: 'post',
    data:{
      id
    }
  })
}
//获取店铺编辑信息
export const getShopEdit = id => {
  return request({
    url: "/api/shop/EditPage",
    method: 'post',
    data:{
      id
    }
  })
}
//修改店铺编辑信息
export const setShopEdit = data => {
  return request({
    url: "/api/shop/Edit",
    method: 'post',
    data
  })
}
//修改个人店铺编辑信息
export const setPersonalEdit = data => {
  return request({
    url: "/api/shop/EditPersonal",
    method: 'post',
    data
  })
}



//获取店铺审核
export const getApplyList = data => {
    return request({
      url: "/api/shop/GetApplyList",
      method: 'post',
      data
    })
}
//获取店铺套餐
export const getShopGrade = data => {
    return request({
      url: "/api/ShopGrade/List",
      method: 'post',
      data
    })
}

//修改店铺套餐
export const setShopGrade = data => {
  return request({
    url: "/api/ShopGrade/GetEdit",
    method: 'post',
    data
  })
}

//获取入驻审核的店铺信息
// export const getEntryAudit = id => {
//   return request({
//     url: "/api/shop/AuditingPage",
//     method: 'post',
//     data:{
//       id
//     }
//   })
// }

//入驻审核（通过或拒绝）
export const setAuditing = data => {
  return request({
    url: "/api/shop/Auditing",
    method: 'post',
    data
  })
}
//经营类目
export const getCategory = data => {
  return request({
    url: "/api/shop/BusinessCategoryList",
    method: 'post',
    data
  })
}
//类目审核或查看
export const getApplyDetail = id => {
  return request({
    url: "/api/shop/applyDetailpage",
    method: 'post',
    data:{
      id
    }
  })
}
//类目审核
export const setAgreeOrNot = data => {
  return request({
    url: "/api/shop/AgreeOrNot",
    method: 'post',
    data
  })
}

//获取门店数据
export const getShopBranch = data => {
    return request({
      url: "/api/ShopBranch/list",
      method: 'post',
      data
    })
}

//tag 获取门店标签
export const getTagList = data => {
    return request({
      url: "/api/ShopBranch/TagList",
      method: 'post',
      data
    })
}

//tag 新增门店标签
export const addTag = data => {
    return request({
      url: "/api/ShopBranch/AddTag",
      method: 'post',
      data
    })
}


//tag 获取微店列表
export const getVshops = data => {
    return request({
      url: "/api/VShop/GetVshops",
      method: 'post',
      data
    })
}

//tag 获取热门微店列表
export const getHotShop = data => {
  return request({
    url: "/api/VShop/GetHotShop",
    method: 'post',
    data
  })
}

//tag 设置门店冻结
export const setFreeze = (id,url) => {
  return request({
    url: `/api/ShopBranch/${url}Freeze`,
    method: 'post',
    data:{
      shopBranchId:id
    }
  })
}

//门店审核
export const AuditStatus = data => {
  return request({
    url: "/api/ShopBranch/ShopBranchPlatformAuditStatus",
    method: 'post',
    data
  })
}
//门店查看
export const GetShopBranchInfo = data => {
  return request({
    url: "/api/ShopBranch/GetShopBranchInfo",
    method: 'post',
    data
  })
}
//获取财务情况的具体数据

export const ysterDay = data => {
  return request({
    url: "/api/Billing/YesterDay",
    method: 'POST',
    data:{
      ...data
    }
  })
}
//获取财务情况7天内交易情况
export const getSevenDaysTradeChart = data => {
  return request({
    url: "/api/Billing/GetSevenDaysTradeChart",
    method: 'POST',
    data:{
      ...data
    }
  })
}
//获取财务情况进30天交易情况
export const getThirdtyDaysTradeChart = data => {
  return request({
    url: "/api/Billing/GetThirdtyDaysTradeChart",
    method: 'POST',
    data:{
      ...data
    }
  })
}
//获取财务情况本月交易情况
export const getTradeChartMonthChart = data => {
  return request({
    url: "/api/Billing/GetTradeChartMonthChart",
    method: 'POST',
    data:{
      ...data
    }
  })
}
//获取待结算列表
export const pendingSettlementList = data => {
  return request({
    url: "/api/Billing/PendingSettlementList",
    method: 'post',
    data
  })
}
//获取待结算订单列表
export const pendingSettlementOrderList = data => {
  return request({
    url: "/api/Billing/PendingSettlementOrderList",
    method: 'post',
    data
  })
}
//获取待结算订单详情列表
export const PendingSettlementDetailPage = data => {
  return request({
    url: "/api/Billing/PendingSettlementDetailPage",
    method: 'post',
    data
  })
}
//获取已结算列表
export const BilSettlementList = data => {
  return request({
    url: "/api/Billing/SettlementList",
    method: 'post',
    data
  })
}
//获取已结算列表详情
export const SettlementOrderList = data => {
  return request({
    url: "/api/Billing/SettlementOrderList",
    method: 'post',
    data
  })
}
//获取结算明细列表
export const GetPlatAccountItemlist = data => {
  return request({
    url: "/api/Billing/GetPlatAccountItemlist",
    method: 'post',
    data
  })
}
//获取结算明细详情
export const MarketServiceRecord = data => {
  return request({
    url: "/api/Billing/MarketServiceRecord",
    method: 'get',
    params:{
      ...data
    }
  })
}
// 结算周期设置获取
export const GetSetSettlementWeek = data => {
  return request({
    url: "/api/Account/GetSetSettlementWeek",
    method: 'get',
    data
  })
}
// 结算周期设置保存
export const PostUpdateSettlementWeek = data => {
  return request({
    url: "/api/Account/PostUpdateSettlementWeek",
    method: 'post',
    data
  })
}
//获取结算明细类型列表
export const GetPlatAccountItemType = data => {
  return request({
    url: "/api/Billing/GetPlatAccountItemType",
    method: 'get',
    data
  })
}
//获取待结算列表预期时间
export const pendingSettlementDate = data => {
  return request({
    url: "/api/Billing/PendingSettlementDate",
    method: 'post',
    data
  })
}
//删除类目
export const deleteCategory = data => {
  return request({
    url: "/api/shop/CanDeleteBusinessCategory",
    method: 'post',
    data
  })
}

//设置类目分佣比例
export const setBusiness = data => {
  return request({
    url: "/api/shop/SaveBusinessCategory",
    method: 'post',
    data
  })
}

//新增类目
export const addCategory = data => {
  return request({
    url: "/api/shop/AddShopCommisRate",
    method: 'post',
    data
  })
}
//商品管理（门店）
export const getGoodsList = data => {
  return request({
    url: "/api/ShopBranch/ProductList",
    method: 'post',
    data
  })
}



//获取商品分类
export const getGoodsClassify = id => {
  return request({
    url: "/api/ShopBranch/ShopCategorys",
    method: 'post',
    data:{
      shopBranchId:id
    }
  })
}
//获取商家提现
export const getShopWithDraw = data => {
  return request({
    url: "/api/ShopWithDraw/List",
    method: 'post',
    data
  })
}

//商家提现审核
export const setConfirmPay = data => {
  return request({
    url: "/api/ShopWithDraw/ConfirmPay",
    method: 'post',
    data
  })
}

//取消提现
export const setCancelPay = Id => {
  return request({
    url: "/api/ShopWithDraw/CancelPay",
    method: 'post',
    data:{
      Id
    }
  })
}
//获取提现金额设置
export const getWithdrawSetting = data => {
  return request({
    url: "/api/ShopWithDraw/SettingPage",
    method: 'post',
    data
  })
}
//获取提现金额设置
export const saveWithDrawSetting = data => {
  return request({
    url: "/api/ShopWithDraw/SaveWithDrawSetting",
    method: 'post',
    data
  })
}

//获取门店标签列表
export const getShopLabel = data => {
  return request({
    url: "/api/ShopBranch/GetLabel",
    method: 'post',
    data
  })
}

//获取门店地址
export const StoresLink = data => {
  return request({
    url: "/api/ShopBranch/StoresLink",
    method: 'post',
    data
  })
}


























